import './honeypotField.css';

type HoneypotFieldProps = {
    value: string;
    onChange: (value: string) => void;
};

/**
 * Bait for form-filling bots: a real input that no visitor ever sees or reaches.
 * It is kept out of the tab order and the accessibility tree, so anything typed
 * into it came from a script.
 *
 * It deliberately avoids `type="hidden"` and `display: none` — bots skip both,
 * which would defeat the purpose.
 */
function HoneypotField({ value, onChange }: HoneypotFieldProps) {
    return (
        <div className="sp-honeypot" aria-hidden="true">
            <label htmlFor="website">Website</label>
            <input
                type="text"
                id="website"
                name="website"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                tabIndex={-1}
                autoComplete="off"
            />
        </div>
    );
}

export default HoneypotField;
